exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.header_box[data-v-06351b77] {\n\tposition: fixed;\n\ttop: 0rem;\n\tleft: 0rem;\n\twidth: 100%;\n\t/*z-index: 1900;*/\n}\n.city_box[data-v-06351b77] {\n\tmargin-top: 50px;\n}\n", ""]);

// exports
